import { type ImportCleanupInput, type ImportEntity, type ResponseSuccess, toResponseError } from '@terros/common'
import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useImportCache } from './cache'

export function useImportCleanup(entity: ImportEntity): RemoveHookResponse<ImportCleanupInput> {
  const mutation = useTantalimMutation<ImportCleanupInput, ResponseSuccess>({ url: '/import/cleanup' })
  const cache = useImportCache()

  async function cleanup(input: ImportCleanupInput): Promise<void> {
    try {
      await mutation.mutateAsync(input)
      cache.removeItem(input.importId)
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, cleanup)
}
